import { render, staticRenderFns } from "./SupplierApprovals.vue?vue&type=template&id=3ee57c38&scoped=true"
import script from "./SupplierApprovals.vue?vue&type=script&lang=js"
export * from "./SupplierApprovals.vue?vue&type=script&lang=js"
import style0 from "./SupplierApprovals.vue?vue&type=style&index=0&id=3ee57c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee57c38",
  null
  
)

export default component.exports